import React, { forwardRef, useState, useCallback } from 'react'
import { IconButton, Tooltip } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog } from '@fortawesome/pro-duotone-svg-icons/faCog'
import { Block, BaseBlockProps } from '../types'
import BlockForm from '../../../Index/BlockForm'

interface BlockEditButtonProps {
    kedo: BaseBlockProps['kedo']
    item: Block
    onSuccess?: () => void
}

export const BlockEditButton = forwardRef<
    HTMLButtonElement,
    BlockEditButtonProps
>(({ kedo, item, onSuccess }, ref) => {
    const [showModal, setShowModal] = useState(false)

    const handleOpen = useCallback(() => {
        setShowModal(true)
    }, [])

    const handleClose = useCallback(() => {
        setShowModal(false)
    }, [])

    const handleSuccess = useCallback(
        (updated: boolean) => {
            setShowModal(false)
            if (updated) {
                onSuccess?.()
            }
        },
        [onSuccess]
    )

    return (
        <>
            <Tooltip title={kedo.t('Settings')}>
                <IconButton ref={ref} size="small" onClick={handleOpen}>
                    <FontAwesomeIcon icon={faCog} />
                </IconButton>
            </Tooltip>
            {showModal && (
                <BlockForm
                    kedo={kedo}
                    item={item}
                    variant="edit"
                    onClose={handleClose}
                    onSuccess={handleSuccess}
                />
            )}
        </>
    )
})

BlockEditButton.displayName = 'BlockEditButton'
